import mapboxgl from "mapbox-gl";

export const tripsSources = {
    unladenStartPtSrc: "unladen_start_loc",
    deliverStartLocSrc: "deliver_start_loc",
    naviShapeSrc: "navi_shape",
    unladenShapeSrc: "unladen_shape",
    goCancelLocSrc: "go_cancel_loc",
};

export const addSourcesIfNotExist = (
    map: mapboxgl.Map,
    source_names: string[]
): void => {
    source_names.forEach((source_name: string) => {
        if (!map.getSource(source_name)) {
            map.addSource(source_name, {
                type: "geojson",
                data: {
                    type: "FeatureCollection",
                    features: [],
                },
                generateId: true,
                promoteId: "id",
            });
        }
    });
};

export const initSources = (map: mapboxgl.Map): void => {
    addSourcesIfNotExist(map, Object.values(tripsSources));
};
